export default {
    "name": "InterchangeScreenModels",
    "kind": "HoudiniQuery",
    "hash": "047f6ae23f8e381326d7dc968f68a9138a0dd73c245b0d7b690fbbb7ee56eaad",

    "raw": `query InterchangeScreenModels($filter: ModelFilter) {
  models(filter: $filter) {
    id
    name
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "models": {
                "type": "Model",
                "keyRaw": "models(filter: $filter)",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "Int",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "filter": "ModelFilter"
        },

        "types": {
            "ModelFilter": {
                "active": "Boolean",
                "id": "UInt",
                "inventoryTypeId": "UInt",
                "manufacturerId": "UInt",
                "name": "String"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=eeaee0c416b8ff9023e36bac4961170104e3af6392121a7d8d639627931aff32";